/**
 * Authors: mariushirjanu
 * Created: 16/01/2021
 */
import { Injectable } from '@angular/core';
import { HttpDataService } from '../http/http-data.service';
import { IDocument, IValueObject } from '@type_definitions/datatypes';

export enum DocumentOrigin {
  WEBSHOP = 'WEBSHOP',
  FAQ = 'FAQ'
}

export enum DocumentTypeCode {
  CENTRAL_BILLING_CONTRACT = 'CENBILCONT',
  B2B_PROCESS = 'B2BPROCESS',
  LEASING_CONTRACT = 'LEASE_CTR',
  CAVEATS = 'PO_CAVEAT',
  PICTURE = 'PIC'
}

export enum DocumentUploadSource {
  TINYMCE_EDITOR = 'editor'
}

export enum DocumentNameType {
  CENTRAL_BILLING_LAM_CONTRACT = 'CENTRAL_BILLING_CONTRACT_TEMPLATE_LAM',
  CENTRAL_BILLING_CUSTOMER_CONTRACT = 'CENTRAL_BILLING_CONTRACT_TEMPLATE_CUSTOMER',
  CENTRAL_BILLING_SIGNED_CONTRACT = 'CENTRAL_BILLING_SIGNED_CONTRACT',
  CUSTOMER_B2B_QUESTIONNAIRE_FORM = 'CUSTOMER_B2B_QUESTIONNAIRE_FORM'
}

export interface IDocumentData {
  documentType:string;
  attachments:IValueObject[];
}

export enum DocumentTableReference {
  FAQ = 'DRFAQST'
}

export const DOCUMENTS_URL:string = 'rest/documents';
export const TEMP_DOCUMENTS_UPLOAD_URL:string = 'rest/documents/temp';

@Injectable()
export class DocumentDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {/**/
  }

  public getDocuments(tableReference:DocumentTableReference, recordId:number):Promise<IDocument[]> {
    return this.httpDataService.doGET(
      DOCUMENTS_URL,
      {
        tableReference,
        recordId
      },
      undefined,
      'Error loading documents'
    );

  }

  public updateDocument(document:IDocument):Promise<IDocument> {
    const url:string = `${DOCUMENTS_URL}/${document?.id}`;
    return this.httpDataService.doPUT(
      url,
      undefined,
      document,
      'Saving document',
      'Error saving document'
    );
  }

  public deleteDocumentByUrl(url:string):Promise<void> {
    return this.httpDataService.doDELETE(
      url,
      undefined,
      undefined,
      'Error deleting document'
    );
  }

  public getDocumentsUrls(docOrigin:string, recordId:number, docTypeCode?:string):Promise<IDocumentData[]> {
    return this.httpDataService.doGET(
      'rest/documents/urls',
      {
        docOrigin,
        docTypeCode,
        recordId
      },
      undefined,
      'Error loading documents'
    );
  }
}